/**
 * Centralized color configuration for NCB Interpol style
 * This ensures consistent color usage across all profile pages
 */

export const ncbInterpolColors = {
  // Header gradient colors
  header: {
    gradient: "bg-gradient-to-r from-primary to-primary-focus",
    text: "text-primary-content",
    subtext: "text-primary-content/80",
    iconBg: "bg-white/20",
  },

  // Page background and containers
  background: {
    page: "bg-base-100",
    card: "bg-base-100",
    section: "bg-base-200",
    border: "border-base-300",
  },

  // Text colors
  text: {
    primary: "text-base-content",
    secondary: "text-base-content/70",
    tertiary: "text-base-content/60",
    hover: "text-base-content/80",
  },

  // Tab navigation
  tabs: {
    active: {
      border: "border-primary",
      text: "text-primary",
    },
    inactive: {
      border: "border-transparent",
      text: "text-base-content/60",
      hover: "hover:text-base-content/80 hover:border-primary/30",
    },
  },

  // Footer
  footer: {
    gradient: "bg-gradient-to-r from-primary to-primary-focus",
    text: "text-primary-content",
    subtext: "text-primary-content/80",
    statText: "text-primary-content/70",
    divider: "bg-primary-content/40",
  },

  // Common component styles
  common: {
    shadow: "shadow-2xl",
    rounded: "rounded-2xl",
    roundedSmall: "rounded-xl",
    roundedFull: "rounded-full",
  },

  // Accent elements
  accent: {
    bullet: "text-primary",
    highlight: "bg-primary/10",
  },
};

// Helper function to get consistent class names
export const getNCBClasses = {
  pageContainer: () => `min-h-screen ${ncbInterpolColors.background.page}`,

  headerSection: () =>
    `
    ${ncbInterpolColors.background.card} 
    ${ncbInterpolColors.text.primary} 
    ${ncbInterpolColors.common.rounded} 
    ${ncbInterpolColors.common.shadow} 
    border ${ncbInterpolColors.background.border} 
    overflow-hidden
  `.trim(),

  headerGradient: () =>
    `
    ${ncbInterpolColors.header.gradient} 
    px-8 py-6
  `.trim(),

  tabButton: (isActive: boolean) =>
    `
    py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200
    ${
      isActive
        ? `${ncbInterpolColors.tabs.active.border} ${ncbInterpolColors.tabs.active.text}`
        : `${ncbInterpolColors.tabs.inactive.border} ${ncbInterpolColors.tabs.inactive.text} ${ncbInterpolColors.tabs.inactive.hover}`
    }
  `.trim(),

  footerSection: () =>
    `
    mt-12 
    ${ncbInterpolColors.footer.gradient} 
    ${ncbInterpolColors.common.rounded} 
    p-8 
    ${ncbInterpolColors.footer.text}
  `.trim(),
};
